import variables from '../../variables.module.scss';

const MuiSvgIcon = {
  styleOverrides: {
    colorPrimary: {
      color: variables.svgIconPrimaryColor,
    },
    colorSecondary: {
      color: variables.svgIconSecondaryColor,
    },
  },
};

export default MuiSvgIcon;
